import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { id: "nav" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Shell")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_router_link, { to: "/shell" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view)
  ]))
}